var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_header"},[_c('span',{staticClass:"back text_size_14 text_color_regular",on:{"click":_vm.back}},[_vm._v("\n    "+_vm._s(_vm.$t('topedit.layout.header.back'))+"\n  ")]),_c('span',{staticClass:"line"}),_c('span',{staticClass:"title text_size_18 text_weight_bold"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac63434","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-header/index.vue
// module id = null
// module chunks = 